module.exports = __webpack_public_path__ + "static/m4r-84f0cb42001ea4ed6feaae987e84e9ca.png";